import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { accountApiSlice, isAnyLogoutMatch } from '../slices/account-api.slice';
import { isLoginMatch } from '../slices/auth-api.slice';
import { localeKey } from '../../i18n';

const middleware = createListenerMiddleware();

middleware.startListening({
    matcher: isAnyOf(isLoginMatch, isAnyLogoutMatch),
    effect: (action, api) => {
        if (isLoginMatch(action)) {
            localStorage.setItem('loggedIn', 'true');
        }

        if (isAnyLogoutMatch(action)) {
            localStorage.removeItem('loggedIn');
            localStorage.removeItem(localeKey);
            // must reset the api state on logout
            api.dispatch(accountApiSlice.util.resetApiState());
        }
    }
});

export const sessionMiddleware = middleware;
